// "Last used" sign-in badge cookie — written only after backend validation so a Cognito-accepted but app-rejected method is never promoted.
const COOKIE_NAME = "arrivo_last_auth_preference";

// Map a Cognito user's idToken identities to "google" | "apple" | "email" (null when undetectable).
export const getAuthProvider = (cognitoUser) => {
  const payload = cognitoUser?.signInUserSession?.idToken?.payload;
  if (!payload) return null;
  if (!payload.identities) return "email";
  try {
    let identities = payload.identities;
    if (typeof identities === "string") {
      identities = JSON.parse(identities);
    }
    const provider = Array.isArray(identities) ? identities[0]?.providerName : null;
    if (provider === "Google") return "google";
    if (provider === "SignInWithApple") return "apple";
  } catch (e) {
    console.warn("lastAuthMethod - Failed to parse identities:", payload.identities, e);
  }
  return null;
};

export const getLastAuthMethod = () => {
  const match = document.cookie.split("; ").find((c) => c.startsWith(`${COOKIE_NAME}=`));
  return match ? decodeURIComponent(match.split("=")[1]) : null;
};

// Cookie survives Auth.signOut (which clears localStorage).
export const setLastAuthMethod = (provider) => {
  if (!provider) return;
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(provider)}; path=/; max-age=31536000; SameSite=Strict`;
};

// Clear only when the cookie points at the method that just failed — never wipe a different, working method.
export const clearLastAuthMethodIf = (provider) => {
  if (!provider || getLastAuthMethod() !== provider) return;
  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Strict`;
};
